import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LinearProgress } from 'components/linear-progress';

interface WizardProgressProps {
  current: number;
  total: number;
  label: string;
}

export const WizardProgress = ({ current, total, label }: WizardProgressProps) => {
  const { t } = useTranslation();
  const value = total > 0 ? (current / total) * 100 : 0;

  return (
    <Stack gap={1} sx={{ width: '100%' }}>
      <LinearProgress variant="determinate" value={value} />
      <Typography variant="textXs" sx={{ color: 'text.secondary' }}>
        {t('wizard.progress', { current, total, label })}
      </Typography>
    </Stack>
  );
};
